import { AxiosService } from './';

const getProjectPayoutList = async (
  _perPage,
  _page,
  commonSearch,
  investmentType,
  status,
) => {
  try {
    let axiosData = {
      method: 'get',
      url: 'admin/project_payouts',
      isAuthorized: true,
      params: {
        perPage: _perPage || 10,
        page: _page || 1,
        commonSearch: commonSearch,
        investmentType: investmentType,
        status: status,
      },
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};
const updatePayoutStatus = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'admin/project_payouts/update_payout_status',
      isAuthorized: true,
      formData: _formData,
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

const generateDividend = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'admin/project_payouts/generate_dividend',
      isAuthorized: true,
      formData: _formData,
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

const generatePayoutXML = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'admin/project_payouts/generate_payout_xml',
      isAuthorized: true,
      formData: _formData,
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

const generateDividendPreview = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'admin/project_payouts/generate_dividend_preview',
      isAuthorized: true,
      formData: _formData,
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

const generatePayout = async (_formData) => {
  try {
    let axiosData = {
      method: _formData.isPreview ? 'get' : 'post',
      url: `admin/project_payouts/generate_payout/${_formData.project_id}`,
      isAuthorized: true,
      formData: _formData,
      ...(_formData.isPreview && {
        params: {
          perPage: _formData.perPage || 10,
          page: _formData.page || 1,
        },
      }),
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

const getUserPayoutList = async (
  _perPage,
  _page,
  commonSearch,
  project_id,
  user_id,
  payout_id,
) => {
  try {
    let axiosData = {
      method: 'get',
      url: 'admin/project_payouts/users_payout_list',
      isAuthorized: true,
      params: {
        perPage: _perPage || 10,
        page: _page || 1,
        commonSearch: commonSearch,
        project_id: project_id,
        user_id: user_id,
        payout_id: payout_id,
      },
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

const projectRepayment = async (project_id) => {
  try {
    let axiosData = {
      method: 'post',
      url: `admin/project_payouts/repayment/${project_id}`,
      isAuthorized: true,
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

export {
  getProjectPayoutList,
  updatePayoutStatus,
  generateDividend,
  getUserPayoutList,
  generateDividendPreview,
  generatePayoutXML,
  generatePayout,
  projectRepayment,
};
